import React, { useEffect } from 'react';
import { useOutletContext } from "react-router-dom";
import Feature5 from './Feature5';
import { Feature50DataSource } from './data.source';
import './style.less';
import { Helmet } from 'react-helmet';

const News = () => {
  const { onEnterChange, isMobile } = useOutletContext();

  useEffect(() => {
    onEnterChange(false);
  }, []);

  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" />
        <title>爱瑟福信息科技(上海)有限公司-新闻动态</title>
      </Helmet>
      <Feature5
        id="Feature5_0"
        key="Feature5_0"
        dataSource={Feature50DataSource}
        isMobile={isMobile}
      />
    </div>

)
}

export default News;
